module.exports = __webpack_public_path__ + "static/media/github.9b043902.png";